export enum HsaReimbursementClaimStatus {
  Pending = "pending",
  Submitted = "submitted",
  ManualReceipt = "manual_receipt",
  Failed = "failed",
}
